import * as React from 'react';
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiThemeProvider} from '@material-ui/core/styles';
import CostCenterDialog from '../CreateDialogue/CostCenterDialog';
import EditCostCenterDialog from '../EditDialogue/EditCostCenterDialog';
import SiteDialog from '../CreateDialogue/SiteDialog';
import DiscountDialog from '../CreateDialogue/DiscountDialog';
import { muiThemeDesign } from '../../mui-theme-design';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import {logger, customBodyForExcelReport,handleExport,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');

export default function CostCenterTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [companies, setCompanies] = React.useState([]);
    const [siteList, setSiteList] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        if (refresh) {
            fetch('api/cost_center', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setCompanies(json))

            fetch('api/site', {
                method: 'Get',
            })
                .then(res => res.json())
				.then(json => {
					setSiteList(json);
					setIsLoading(false);
				})
            setRefresh(false);
        }
    })

    const handleDialogCallback = (childData) => {
        fetch("api/cost_center", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "cost_center": [{
                    "SiteID": childData.SiteID,
                    "CommonName": childData.CommonName,
                    "CostCenter": childData.CostCenter,
                    "Name": childData.Name,
                    "CostCenterDateLock": childData.CostCenterDateLock,
                    "IsActive": childData.IsActive
                }]
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const handleEditCallback = (childData) => {
        fetch("api/cost_center", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "cost_center": {
                    "ID": childData.ID,
                    "CommonName": childData.CommonName,
                    "SiteID": childData.SiteID,
                    "CostCenter": childData.CostCenter,
                    "Name": childData.Name,
                    "CostCenterDateLock": childData.CostCenterDateLock,
                    "IsActive": childData.IsActive
                }
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const handleDiscountDialogCallback = (childData) => {
        fetch("api/Discount", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "SiteID": childData.SiteID,
                "Discount": childData.Discount,
                "StartDate": childData.StartDate,
                "EndDate": childData.EndDate,
                "IsActive": childData.IsActive
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const handleSiteDialogCallback = (childData) => {
        fetch("api/site", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "Name": childData.Name,
                "Location": childData.Location,
                "Address": childData.Address,
                "IsActive": childData.IsActive
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const siteColumns = [


        {
            name: "Discount",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            <DiscountDialog handleDiscountDialogCallback={handleDiscountDialogCallback} data={siteList[dataIndex]} />
                        </div>
                    );
                }

            }
        },
        {
            name: "Name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Location",
            label: "Location",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Address",
            label: "Address",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Discount",
            label: "Discount",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "IsActive",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            {(siteList[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );
                }
            }
        }
    ];

    const companiesColumns = [


        {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            <EditCostCenterDialog handleEditCallback={handleEditCallback} data={siteList[dataIndex]} />
                        </div>
                    );
                }

            }
        },
        {
            name: "Name",
            label: "Cost Center Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "CostCenter",
            label: "Cost Center",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Location",
            label: "Location",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Address",
            label: "Address",
            options: {
                filter: false,
                sort: true,
            }
        }
    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
        rowsPerPageOptions: [10, 20, 50, 100],
        rowsPerPage: initialRowsPerPage, // Use the initial value retrieved from local storage
        selectableRows: 'none',
		  onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename:'CostCenter.xlsx', columnIndexToRemove:0});
			return false;
		},
		customToolbar: () => {
			if (!isLoading) {
				return (
					<>
						<CostCenterDialog handleDialogCallback={handleDialogCallback} />
						<SiteDialog handleSiteDialogCallback={handleSiteDialogCallback} />
					</>
				);
			}
			return null; 
		},
		expandableRows: true,
		renderExpandableRow: (rowData, rowMeta) => {
			//data={companies.filter(obj => { return obj.SiteID === siteList[rowMeta.dataIndex].ID })}

			options.onChangeRowsPerPage = (newRowsPerPage) => {
                saveRowsPerPage(newRowsPerPage);
            };

            return (
                <React.Fragment>
                    <tr style={{ backgroundColor: "#FFFFFF" }}>
                        <td colSpan={8}>
                            <Table size="small" aria-label="TimeLogged">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ width: 100 }}>Admin Actions</TableCell>
                                        <TableCell align="right">Cost Center Name</TableCell>
                                        <TableCell align="right">Cost Center</TableCell>
                                        <TableCell align="right">Location</TableCell>
                                        <TableCell align="right">Address</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {companies.filter(obj => { return obj.SiteID === siteList[rowMeta.dataIndex].ID }).map((company) => (
                                        <TableRow >
                                            <TableCell style={{ width: 100 }}><EditCostCenterDialog handleEditCallback={handleEditCallback} data={company} /></TableCell>
                                            <TableCell align="right">{company.Name}</TableCell>
                                            <TableCell align="right">{company.CostCenter}</TableCell>
                                            <TableCell align="right">{company.Location}</TableCell>
                                            <TableCell align="right">{company.Address}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </td>
                    </tr>          
                </React.Fragment>
            );
        }
    };

    return (
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="CompaniesTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Site
                        </Typography>
                    }
                    data={isLoading ? [] :siteList}
                    columns={siteColumns}
                    options={muiLoaderOptions(options, isLoading)}

                />
                </Box>
            </MuiThemeProvider>
        </Box>
    );
}